import(/* webpackMode: "eager", webpackExports: ["TeacherCard"] */ "/vercel/path0/src/components/teachers/TeacherCard.tsx");
